<template>
    <div style="width: 100%;">
      <div v-if="attr.type === 1000">
      <v-text-field
        readonly
        v-model="values[attr.identifier]"
        :label="attr.name.ru"
        :append-outer-icon="'mdi-form-select'"
         @click:append-outer="showDialog"
      />
      </div>
      <v-dialog v-model="dialogRef" persistent width="80%">
        <v-card>
          <v-card-title>Товары поставщика</v-card-title>
          <v-card-text>
            <v-simple-table dense class="mb-4" v-if="!loadingRef">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="width:70%">Товар поставщика</th>
                    <th class="text-left" style="width:20%">Количество</th>
                    <th style="width:20%">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" class="pa-0" icon color="primary" @click="add()"><v-icon dark>mdi-plus</v-icon></v-btn>
                        </template>
                        <span>{{ $t('Add') }}</span>
                      </v-tooltip>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(elem, i) in itemsRef" :key="i">
                    <td class="pa-1">
                      <a :href="'#/item/' + elem.target.identifier" target="_blank">{{ elem.target.name.ru }}</a>
                    </td>
                    <td class="pa-1">
                      <input type="number" v-model=elem.values.supplierItemsCount min="1"/>
                    </td>
                    <td>
                      <v-btn class="pa-0" icon @click="remove(elem, i)"><v-icon dark>mdi-delete-outline</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-container class="pa-4" v-else>
              <v-progress-linear indeterminate></v-progress-linear>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="save" :disabled="loadingRef">{{ $t('Save') }}</v-btn>
            <v-btn color="blue darken-1" text @click="dialogRef = false">{{ $t('Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ItemsSelectionDialog ref="itemSelectionDialogRef" @selected="itemsSelected"/>
    </div>
  </template>

<script>
import * as itemStore from '@/store/item'
import * as itemRelStore from '@/store/itemRelations'
import { ref } from '@vue/composition-api'
import ItemsSelectionDialog from '@/components/ItemsSelectionDialog'

export default {
  components: { ItemsSelectionDialog },
  props: {
    values: {
      required: true
    },
    attr: {
      required: true
    },
    item: {
      required: true
    }
  },
  setup (props, { emit, root }) {
    const dialogRef = ref(false)
    const itemsRef = ref(false)
    const itemSelectionDialogRef = ref(null)
    const loadingRef = ref(false)

    const {
      loadItemsByIds
    } = itemStore.useStore()

    const {
      loadSourceRelations,
      sourceRelations,
      removeItemRelation,
      saveItemRelation
    } = itemRelStore.useStore()

    const showDialog = () => {
      loadingRef.value = true
      loadSourceRelations(props.item, root, 100).then(() => {
        itemsRef.value = [...sourceRelations.supplierItem ? sourceRelations.supplierItem : []]
        itemsRef.value.forEach(el => {
          el.values.supplierItemsCount = el.values.supplierItemsCount ? el.values.supplierItemsCount : 1
        })
        props.values[props.attr.identifier] = generateValueString()
        loadingRef.value = false
      })
      dialogRef.value = true
    }

    const generateValueString = () => {
      const resultArray = []
      for (let i = 0; i < itemsRef.value.length; i++) {
        let result = ''
        const item = itemsRef.value[i]
        result += item.target.name.ru
        result = result.replace('_', '-')
        if (item.values.supplierItemsCount > 1) {
          result += '*' + item.values.supplierItemsCount
        }
        resultArray.push(result)
      }
      resultArray.sort()
      return resultArray.join('+')
    }

    const add = () => {
      itemSelectionDialogRef.value.showDialog({}, [35], true)
    }

    const remove = (elem, i) => {
      itemsRef.value.splice(i, 1)
    }

    const itemsSelected = (id, parameters) => {
      itemSelectionDialogRef.value.closeDialog()
      const existedItem = itemsRef.value.find(el => el.target.id === id)
      if (existedItem) return
      loadItemsByIds([id], false).then(items => {
        const data = { id: -Date.now(), relationId: 8, identifier: props.item.identifier + '_supplierItem_' + items[0].identifier, item: props.item, target: items[0], values: { supplierItemsCount: 1 } }
        itemsRef.value.unshift(data)
      })
    }

    const save = async () => {
      const originalRelations = sourceRelations.supplierItem ? sourceRelations.supplierItem : []
      const rel2Delete = []
      for (let i = 0; i < originalRelations.length; i++) {
        const originalRelation = originalRelations[i]
        const found = itemsRef.value.find(elem => elem.identifier === originalRelation.identifier)
        if (!found) {
          rel2Delete.push(originalRelation.id)
        }
      }
      for (let i = 0; i < rel2Delete.length; i++) {
        const id = rel2Delete[i]
        await removeItemRelation('source', 'supplierItem', id)
      }

      for (let i = 0; i < itemsRef.value.length; i++) {
        const itemRel = itemsRef.value[i]
        await saveItemRelation(itemRel)
      }
      props.values[props.attr.identifier] = generateValueString()
      dialogRef.value = false
      emit('change', props.values[props.attr.identifier])
    }

    return {
      dialogRef,
      itemsRef,
      add,
      itemsSelected,
      itemSelectionDialogRef,
      remove,
      save,
      loadingRef,
      showDialog
    }
  }
}
</script>
